import {
  ZadCategory,
  ZadCategoryRef,
  ZadCategoryWritePayload,
  ZadProductType,
  ZadProductTypeWritePayload,
} from '../../../models/zad'

export function normalizeZadCode(code: string | undefined | null): string {
  if (code == null) return ''
  return String(code).trim().toUpperCase()
}

export function getZadCategoryId(
  category: ZadProductType['category'] | ZadCategory | ZadCategoryRef | string | null | undefined
): string {
  if (!category) return ''
  if (typeof category === 'string') return category
  if (typeof category === 'object' && category._id) return String(category._id)
  return ''
}

export function getZadCategoryLabel(
  category: ZadProductType['category'] | ZadCategory | ZadCategoryRef | string | null | undefined
): string {
  if (!category) return ''
  if (typeof category === 'string') return ''
  if (typeof category === 'object') return category.name || ''
  return ''
}

export function toZadCategoryPayload(values: {
  name: string
  code: string
  description?: string
  icon?: string
}): ZadCategoryWritePayload {
  return {
    name: String(values.name || '').trim(),
    code: normalizeZadCode(values.code),
    description: values.description != null ? String(values.description).trim() : '',
    icon: values.icon != null ? String(values.icon).trim() : '',
  }
}

export function toZadProductTypePayload(values: {
  name: string
  code: string
  category: ZadProductType['category'] | string
  description?: string
  icon?: string
}): ZadProductTypeWritePayload {
  return {
    name: String(values.name || '').trim(),
    code: normalizeZadCode(values.code),
    category: getZadCategoryId(values.category),
    description: values.description != null ? String(values.description).trim() : '',
    icon: values.icon != null ? String(values.icon).trim() : '',
  }
}

export function getActiveZadCategories(categories: ZadCategory[] = []): ZadCategory[] {
  return categories.filter((category) => category.isActive)
}

export function canCreateZadProductType(categories: ZadCategory[] = []): boolean {
  return getActiveZadCategories(categories).length > 0
}

export function mergeCurrentCategoryOption(
  options: ZadCategory[],
  current: ZadProductType['category'] | null | undefined
): ZadCategory[] {
  const currentId = getZadCategoryId(current)
  if (!currentId) return options
  if (options.some((option) => option._id === currentId)) return options
  if (current && typeof current === 'object') {
    return [
      {
        _id: current._id,
        name: current.name,
        code: current.code,
        icon: current.icon,
        isActive: current.isActive !== false,
        description: '',
      },
      ...options,
    ]
  }
  return options
}
